import axios from "axios";
import jwt_decode from "jwt-decode";
import router from '../../router/index';

export const SidebarToggle = {
    namespaced: true,
    state: {
        sidebar_toggled: false,
        adding_favourite_company: false,
        my_favourite_companies: [],
        all_favourite_companies: [],
        current_favourite: "",
        current_favourite_tickets: [],
        loading_current_fav: true,
        current_fav_ticketNumbers: 0,
        current_fav_loadingNextDataSet: false,
        loadingPageData: true,
    },
    mutations: {
        togglesidebar(state:any) {
            state.sidebar_toggled = !state.sidebar_toggled;
        },
        change_adding_fav_status(state: any) {
            state.adding_favourite_company = !state.adding_favourite_company;
        },
        addFavCompany(state: any, value: any) {
            if (value == undefined) {
                alert("You must select a favourite company");
                state.adding_favourite_company = false;
                return;
            }

            if (state.my_favourite_companies.includes(value)) {
                alert("Company already part of you favourites");
                state.adding_favourite_company = false;
                return;
            }

            if (state.my_favourite_companies.length == 3) {
                alert("Company already part of you favourites");
                state.adding_favourite_company = false;
                return;
            }

            if(value != '' && !state.my_favourite_companies.includes(value)) {
                var token:any = localStorage.getItem("jwt");
                var decoded:any = jwt_decode(token); 
                var userId:any = decoded.id;   
                state.my_favourite_companies.unshift(value);
                let __addfavourite = `https://bookinga.herokuapp.com/api/v1/client/favorites`;
                let config = {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem("jwt")
                    }
                }

                let fav_companies_data = {
                    "companyname": value,
                    "userId": userId
                  }
    
                axios.post(__addfavourite, fav_companies_data, config)
                    .then(() => {}).catch(() => {})

                state.adding_favourite_company = false;
            }
            
        },
        getAllCompanies(state: any) {
            let __getallcompanies = 'https://bookinga.herokuapp.com/api/v1/company/names'

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }

            if (state.all_favourite_companies.length <= 0) {
                axios.get(__getallcompanies, config)
                    .then(response => {
                        for (let i = 0; i < response.data.data.length; i++) {
                            state.all_favourite_companies.push(response.data.data[i].companyname);
                        }
                        
                    }).catch(() => {}) 
            }
        },
        getMyFavouriteCompanies(state: any) {
            var token:any = localStorage.getItem("jwt");
            var decoded:any = jwt_decode(token); 
            var userId:any = decoded.id; 
            let __getmycompanies = `https://bookinga.herokuapp.com/api/v1/client/favorites/${userId}`

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }

            if (state.my_favourite_companies.length <= 0) {
                axios.get(__getmycompanies, config)
                    .then(response => {
                        state.my_favourite_companies = response.data.data[0].companyname;
                    }).catch(() => {}) 
            }
        },
        removeFavourite(state: any, index: any) {
            if(index != null && index != undefined) {
                let removed_item = state.my_favourite_companies[index];
                state.my_favourite_companies.splice(index, 1);
                let __removefavourite = 'https://bookinga.herokuapp.com/api/v1/client/favorites';
                let config = {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem("jwt")
                    }
                }
                var token:any = localStorage.getItem("jwt");
                var decoded:any = jwt_decode(token); 
                var userId:any = decoded.id; 

                let fav_companies_data = {
                    "name": removed_item,
                    "userId": userId
                }
    
                axios.put(__removefavourite, fav_companies_data, config)
                    .then(() => {}).catch(() => {})
            } else {
                alert("Unable to identify favourite. Try again");
                return;
            }
        },
        getCurrentFavTickets(state: any) {
            let __getcompanytickets = 'https://bookinga.herokuapp.com/api/v1/busSchedule/company/'

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }

            if (state.current_favourite != "") {
                let requestData: any = {
                    "companyname": state.current_favourite
                }
                axios.get(`${__getcompanytickets}${state.current_favourite}`, config)
                    .then(response => {
                        for (let i = 0; i < response.data.data.length; i++) {
                            if (response.data.message) {
                                let company_name = state.current_favourite;
                                if (response.data.message == `No bus schedule found for company ${company_name}`) {
                                    state.current_fav_ticketNumbers = 0;
                                }
                            } else {
                                if (response.data.data) {
                                    state.current_favourite_tickets = response.data.data;
                                    state.current_fav_ticketNumbers = response.data.data.length;
                                } else {
                                    state.current_fav_ticketNumbers = 0;
                                }
                            }
                            state.loading_current_fav = false;
                        }

                    }).catch(() => {
                        state.current_fav_ticketNumbers = 0;
                        state.loading_current_fav = false;
                    }) 
            }
        },
        setCurrentFavourite(state: any, current: any) {
            if (current) {
                if (current != undefined) {
                    state.current_favourite = current;
                    if (state.current_favourite != undefined) {
                        router.push(`/favourites/bus?company=${state.current_favourite}`);
                        state.current_favourite_tickets = [];
                        state.loading_current_fav = true;

                        let __getcompanytickets = 'https://bookinga.herokuapp.com/api/v1/busSchedule/company/'

                        let config = {
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem("jwt")
                            }
                        }
            
                        if (state.current_favourite != "") {
                            axios.get(`${__getcompanytickets}${state.current_favourite}`, config)
                                .then(response => {
                                    for (let i = 0; i < response.data.data.length; i++) {
                                        if (response.data.message) {
                                            let company_name = state.current_favourite;
                                            if (response.data.message == `No bus schedule found for company ${company_name}`) {
                                                state.current_fav_ticketNumbers = 0;
                                            }
                                        } else {
                                            if (response.data.data) {
                                                state.current_favourite_tickets = response.data.data;
                                                state.current_fav_ticketNumbers = response.data.data.length;
                                            } else {
                                                state.current_fav_ticketNumbers = 0;
                                            }
                                        }
                                        state.loading_current_fav = false;
                                    }
            
                                }).catch(() => {
                                    state.current_fav_ticketNumbers = 0;
                                    state.loading_current_fav = false;
                                }) 
                        }
                    }
                }
            }
        },
        loadNextDataSet(state: any) {
            state.current_fav_loadingNextDataSet = true;
        },
        updateLoadingNumber(state: any) {
            state.loadingPageData = false;
        }
    },
    actions: {},
    getters: {
        sidebar_status_getter(state:any) {
            return state.sidebar_toggled = true
        }
    },
    modules: {}
}